import { useQuery } from "react-query";
import { get, API_URL, APIResponse, APIError } from "../api";
import { CartData } from "../@types";

export function useGetCart() {
  const { data, isLoading, isError, error, refetch } = useQuery<
    APIResponse<CartData>,
    APIError
  >("cart", () =>
    get(`${API_URL}/commerce/cart`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
  );

  return {
    cartData: data,
    fetchingCart: isLoading,
    isCartError: isError,
    cartError: error,
    refetchCart: refetch,
  };
}
